import React from 'react';
import { COMMON_TEXT } from '../../helpers/common-text';
import './AuthMethodAlert.less';

/**
 * Auth Method Restriction Alert Component
 * Displays a custom alert box when user's authentication method is not allowed
 */
const AuthMethodAlert = ({ authMethod }) => {
    return (
        <div className="auth-method-alert">
            <div className="alert-icon">
                <i className="pi pi-exclamation-triangle"></i>
            </div>
            <div className="alert-content">
                <div className="alert-message">{COMMON_TEXT.LOGIN_NOT_ALLOWED}</div>
                {/* <div className="alert-detail">{COMMON_TEXT.AUTH_METHOD_RESTRICTION_DETAIL}</div> */}
            </div>
        </div>
    );
};

export default AuthMethodAlert;
